<template>
  <div
    class="
      blog-tag-list
      d-flex
      flex-wrap
    "
    :class="{
      [width]: width,
      container,
    }"
  >
    <div class="row">
      <div class="col">
        <tml-tag
          v-for="tag in tags"
          :key="tag.id"
          class="
            blog-tag-list-item
            mb-2
            mr-3
          "
          :href="tag.url"
        >
          #{{ tag.name }}
        </tml-tag>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlogTagList',

  props: {
    tags: {
      type: Array,
      required: true,
    },

    width: {
      type: String,
      default: 'wide',
    },

    container: {
      type: Boolean,
    },
  },

  data() {
    return {
      meta: {},
    };
  },
};
</script>

<style lang="scss" scoped>
.blog-tag-list {
  &.narrow {
    max-width: 700px;
  }
}
</style>
